/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LogsModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { signpostsWithRange, templatesConfiguration } from 'ng/modules/logs/constants/logs-signpost.constants';
import { getRequestParams, getRLengthRequestParams } from 'ng/modules/logs/utils/logs-signpost.utils';
import { addPoolIdFilterParams } from 'ng/modules/logs/utils/logs.utils';
import { ILogsSignpostTemplateConfig, ILogsSignpostUpdatableParams } from '../../../logs.types';
import { ILogsSignpostStates, LogsSignpostStore } from '../../../services/logs-signpost.store';
import './logs-signpost-default.component.less';

/**
 * @description
 *     Component for displaying default singpost template.
 * @author Suraj Kumar, Yogesh Patil
 */
@Component({
    selector: 'logs-signpost-default',
    templateUrl: './logs-signpost-default.component.html',
})
export class LogsSignpostDefaultComponent implements OnInit {
    /**
     * Selected signpost config key.
     */
    @Input()
    public configKey: string;

    /**
     * The ID of the pool used to filter logs from a VS.
     */
    @Input()
    public poolId?: string;

    /**
     * Selected signpost respective configuration in templatesConfiguration.
     */
    public activeTemplateConfig: ILogsSignpostTemplateConfig;

    constructor(public readonly logsSignpostStore: LogsSignpostStore<ILogsSignpostStates>) {}

    /** @override */
    public ngOnInit(): void {
        this.activeTemplateConfig = templatesConfiguration[this.configKey];

        this.fetchSignpostData();
    }

    private fetchSignpostData(): void {
        let fullSignpostParams: ILogsSignpostUpdatableParams = getRequestParams(this.activeTemplateConfig);

        if (signpostsWithRange.has(this.configKey)) {
            fullSignpostParams = getRLengthRequestParams(fullSignpostParams, this.activeTemplateConfig, this.configKey);
        }

        this.logsSignpostStore.getLogSignpostData(
            addPoolIdFilterParams(fullSignpostParams, this.poolId),
        );
    }
}
